// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"7":"c1369bbe","317":"fef8a54b","719":"5efedf44"}[chunkId] + ".chunk.css";
};